<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: "no",
    prefix: "og: https://ogp.me/ns#",
    class: "font-body bg-green-50",
  },
});

const error = useError();

console.error(error.value);

function handleError(event: Event) {
  // If the error does not prevent JS from being loaded, this will let us clear the error before navigating.
  // If JS is not loaded, the link will work as a normal link.
  let redirect = "/";

  const href = (event.target as HTMLLinkElement)?.href;
  if (typeof href === "string" && href) {
    try {
      const url = new URL(href);
      redirect = url.pathname;
    } catch (e) {
      console.error(e, href);
    }
  } else {
    console.error("Expected href to be a string with non-zero length, but got ", href);
  }

  return clearError({
    redirect,
  });
}
</script>

<template>
  <LayoutSkipTo />
  <LayoutHeader />
  <main class=" bg-green-50">
    <UContainer class="error__hero text-green-30">
      <h1 class="pt-48 pb-8 font-headline text-7xl" aria-label="En feil med applikasjonen oppstått">
        Å nei :(
      </h1>
      <p v-if="error && 'statusCode' in error && error.statusCode === 404">
        Vi finner ikke siden du leter etter.
      </p>
      <p v-else>
        Det har skjedd en feil.
      </p>
      <a href="/" @click.prevent="handleError">
        <UIcon name="fal:arrow-right-long" size="1.75em" /> Til forsiden
      </a>
      <a href="/produktkatalog" @click.prevent="handleError">
        <UIcon name="fal:arrow-right-long" size="1.75em" /> Til produktkatalog
      </a>
      <img
        src="https://media.crystallize.com/au-skole-dev/24/1/2/1/error-group.png"
        aria-hidden="true"
        alt=""
      />
    </UContainer>
    <NuxtErrorBoundary>
      <UiStripesArticles
        class="yellow-light-green"
        :show-all="true"
        :range="[0, 3]"
        title="Siste artikler"
      />
    </NuxtErrorBoundary>
  </main>
  <LayoutFooter />
</template>

<style scoped>
.error__hero {
  p {
    font-size: 2.1rem;
    font-weight: 400;
    margin-bottom: 4rem;
  }

  a {
    font-size: 1.4rem;
    color: var(--color-green-30);
    display: flex;
    gap: 1rem;
    align-items: center;
    margin: 1rem 0;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;

    &:hover {
      color: var(--color-yellow-30);
      transform: translateX(0.5rem);
    }
  }
}
</style>
